module.exports = __webpack_public_path__ + "img/avatar-persona.3fdc5863.svg";